export const philosophyHero = {
  title: '教育理念・方針',
  titleEn: 'OUR PHILOSOPHY',
  lead: '私たちは、技術の習得と人としての品格の涵養を両輪とする執事教育を掲げています。',
};

export const philosophyStatement = {
  mainLine: '先回りの心を、確かな技術で支える。',
  paragraphs: [
    'おもてなしは、生まれ持った素質ではありません。観察し、準備し、所作として繰り返すことで、誰もが確かな技術として身につけられるものだと私たちは考えています。日本執事アカデミーの教育は、精神論や抽象的な「おもてなしの心」だけを語る場ではなく、その心を具体的な所作として再現できる力——つまり「型」を徹底的に訓練する場です。',
    'しかし技術だけでは、真の執事にはなれません。相手の立場に立ち、口に出す前に必要を察し、秘密を守り抜く——こうした人格の土台があってこそ、所作は「かたち」から「もてなし」へと昇華します。私たちのすべての授業は、技術と人格が一体となった執事を育てるために設計されています。',
    'この理念は本科課程だけのものではありません。法人研修で提供する接遇・ビジネスマナー指導にも、同じ思想が流れています。先を読む観察力、相手に合わせた距離感、信頼を損なわない所作——執事教育の本質は、あらゆるサービス業の現場で求められる力です。ただし法人研修では執事資格を付与するものではなく、接遇スキルとしてお伝えしています。',
  ],
  concreteExample:
    'たとえば「先回りの心」を磨く授業では、講師が合図を出す前に受講生が動くロールプレイングを行います。ゲストの仕草や目線の動きを観察し、「次に何が必要か」を察知して自然に動く——この訓練を繰り返すことで、意識しなくても先回りできる身体をつくります。',
};

export const threePolicies = [
  {
    icon: 'ri-tools-line',
    title: '実践に根ざした学び',
    description:
      '座学で終わらせず、必ず実技へと展開します。講義で「なぜその所作が必要か」を理解した後、実際に体を動かして型を覚え、最後にロールプレイングで実戦に近い状況下での応用力を養います。頭と身体の両方で覚えるからこそ、現場で即座に再現できる力になります。',
  },
  {
    icon: 'ri-user-voice-line',
    title: '少人数だからできる個別指導',
    description:
      '1クラス定員6名の完全少人数制。講師は受講生一人ひとりの所作を細部まで確認し、その場で修正します。立ち姿の重心、手の角度、目線の配り方——集団授業では見過ごされがちな微細な癖も、少人数だからこそ見逃さず、確実な習得へと導きます。',
  },
  {
    icon: 'ri-stairs-line',
    title: '段階的に積み上げる体系',
    description:
      '基礎から管理・危機対応まで、3段階のコースで段階的に学びます。エッセンシャルで所作の基盤を固め、アドバンスで応用力を広げ、マスターで管理と判断力を磨く——どの段階からでも始められ、自分の目的に合わせて進める体系です。',
  },
];

export const idealButlerTraits = [
  {
    icon: 'ri-star-line',
    title: '確かな技術',
    description:
      'ティーサービス、テーブルセッティング、クローク管理からVIP対応まで——執事に求められる一連の所作を、どのような場面でも破綻なく再現できる技術力を身につけます。',
  },
  {
    icon: 'ri-heart-line',
    title: '品格と誠実さ',
    description:
      '所作の美しさだけでなく、その所作を支える人格を重視します。相手を思いやる誠実さと、どんな状況でも冷静さを保つ品格——これらを授業のあらゆる場面で涵養します。',
  },
  {
    icon: 'ri-lock-line',
    title: '守秘と信頼',
    description:
      '執事の職業倫理の核心は、知り得た情報を厳守することです。授業では守秘義務の重要性を繰り返し説き、信頼を裏切らない職業人としての自覚を育みます。',
  },
  {
    icon: 'ri-lightbulb-line',
    title: '状況に応じた判断力',
    description:
      'マニュアル通りの対応ではなく、相手・場所・状況を瞬時に読み取り、最善の行動を選び取る判断力を磨きます。ロールプレイングで多数のケースを経験し、応用力を鍛えます。',
  },
];

export const teachingSteps = [
  {
    step: '01',
    title: '講義',
    description:
      '「なぜその所作なのか」を理論から理解します。歴史的背景、おもてなしの原理、サービス哲学を学び、技術の土台となる知識を身につけます。',
  },
  {
    step: '02',
    title: '実技',
    description:
      '講義で学んだ内容を、実際に身体を動かして訓練します。講師の手本を見てから反復練習を行い、「わかる」から「できる」へと転換します。',
  },
  {
    step: '03',
    title: 'ロールプレイング',
    description:
      'ゲスト役と執事役に分かれ、実戦に近い状況で対応力を磨きます。想定外の動きにも臨機応変に対応する力を、繰り返しの訓練で養います。',
  },
  {
    step: '04',
    title: 'フィードバック',
    description:
      '講師が一人ひとりの所作を細かく確認し、修正点と改善の方向を具体的に伝えます。この振り返りが、確実な成長のエンジンです。',
  },
];

export const philosophyFaqs = [
  {
    question: '精神論の研修ですか？',
    answer:
      'いいえ。おもてなしを訓練可能な技術として捉え、所作・サービス・対応力を実技中心に体系立てて指導します。',
  },
  {
    question: '少人数にこだわる理由は？',
    answer:
      '一人ひとりの所作を細かく確認し、その場で修正するためです。定員6名の完全少人数制を採用しています。',
  },
  {
    question: '修了時に評価はありますか？',
    answer:
      'はい。各コース修了時に実技試験を行い、合格者には協会認定資格を授与します。詳しくは修了証・認定資格のページをご覧ください。',
  },
];

export const philosophyRelatedPages = [
  {
    title: '全日本執事協会について',
    description: '運営母体と提供する事業のご紹介',
    href: '/association',
  },
  {
    title: 'コース一覧・比較',
    description: '3つのコースの違いを一覧で確認',
    href: '/courses',
  },
  {
    title: 'カリキュラム概要',
    description: '学びの全体像と進め方',
    href: '/curriculum',
  },
  {
    title: '修了証・認定資格について',
    description: '修了で得られる協会認定資格',
    href: '/certificate',
  },
  {
    title: 'アカデミーについて',
    description: 'アカデミーの全体像',
    href: '/about',
  },
];